import { memo } from "react";
import { Control, FieldErrors } from "react-hook-form";
import { ScrollView } from "@/components/atoms/ScrollView";

import { IForm } from "@/features/notes/type";
import ButtonSubmit from "@/features/notes/components/molecules/ButtonSubmit";
import TextInputField from "@/features/notes/components/molecules/TextInputField";

import { Stack } from "@/components/atoms/Stack";
import { TextInput } from "@/components/atoms/TextInput";
/**
 *
 */
interface Props {
  isValid: boolean;
  loading: boolean;
  onSubmit: () => void;
  control: Control<IForm>;
  errors: FieldErrors<IForm>;
  isSmallScreen: boolean;
}

/**
 * Pure view component for note creation form
 * @param root0 - Component props
 * @param root0.isValid - Whether form validation has passed
 * @param root0.onSubmit - Handler function called when form is submitted
 * @param root0.control - React Hook Form control object for form state management
 * @param root0.errors - Form validation errors object
 * @param root0.loading - Whether note submission is in progress
 * @param root0.isSmallScreen - Whether device has small screen size
 */
const NotesFormView = ({
  isValid,
  onSubmit,
  control,
  errors,
  loading,
  isSmallScreen,
}: Props) =>
  !isSmallScreen ? (
    <>
      <Stack className="flex-1 grow gap-4 px-4 pt-4">
        <TextInputField
          InputTextField={TextInput}
          control={control}
          errors={errors}
          loading={loading}
          isSmallScreen={isSmallScreen}
        />
      </Stack>
      <ButtonSubmit
        loading={loading}
        isValid={isValid}
        onSubmit={onSubmit}
        isSmallScreen={isSmallScreen}
      />
    </>
  ) : (
    <ScrollView
      keyboardShouldPersistTaps="handled"
      contentContainerClassName="grow"
    >
      <Stack className="flex-1 grow gap-4 px-4 pt-4">
        <TextInputField
          InputTextField={TextInput}
          control={control}
          errors={errors}
          loading={loading}
          isSmallScreen={isSmallScreen}
        />

        <ButtonSubmit
          loading={loading}
          isValid={isValid}
          onSubmit={onSubmit}
          isSmallScreen={isSmallScreen}
        />
      </Stack>
    </ScrollView>
  );

NotesFormView.displayName = "NotesFormView";

export default memo(NotesFormView);
